import React from "react";
import DOMPurify from "dompurify";
import Calendar from 'react-calendar'

export default class extends React.Component {


    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.toggleCalender = this.toggleCalender.bind(this);
        this.handleCalenderChange = this.handleCalenderChange.bind(this);
        this.valid = this.valid.bind(this);
        
        const {field, formData} = this.props;
        formData[field.name] = PubHub.util.dayjs(formData[field.name] || field.default).toISOString();
        
        this.state = {
            open: false,
            valid: true
        }
    }

    handleChange(event) {

        const {field, config, formData} = this.props;
        formData[field.name] = event.target.value ? PubHub.util.dayjs(event.target.value).format("YYYY-MM-DD") : ""

        this.valid();

        try {
            this.props.onChange()
        } catch (e) {

        }
    }

    handleCalenderChange(date) {
        const {field, config, formData} = this.props;
        try {

            formData[field.name] = PubHub.util.dayjs(date).format("YYYY-MM-DD")

            this.valid();

            this.toggleCalender();

            this.props.onChange()
        } catch (e) {

        }

    }

    valid() {
        const {field, config, formData} = this.props;

        if (!field.required) {
            return true
        }

        this.setState({
            valid: !!formData[field.name]
        })


    }


    toggleCalender() {
        this.setState({
            open: !this.state.open
        })
    }

    render() {
        const {field, config, formData,id} = this.props;
        const {valid} = this.state;
        const safeHelpText = DOMPurify.sanitize(field.helpText || "", { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
        let title = field.title;
        if(title.substr(-1) == "*"){
            title = title.slice(0, -1)
        }
        if (field.required) {
            title = <span>{title} <span className='pubhub-smartsheet-form-required'>*</span></span>
        }


        const currentValue = formData[field.name];
        const calendarValue = PubHub.util.dayjs(currentValue).toDate();
        const value = currentValue ? PubHub.util.dayjs(currentValue).format("MM/DD/YYYY") : "";


        let calender_el = null;
        if (this.state.open) {
            calender_el = <div className={"pubhub-smartsheet-calendar-container"}>
                <Calendar
                    value={calendarValue}
                    onChange={this.handleCalenderChange}
                /></div>
        }


        return (
            <div
                className={"row pubhub-smartsheet-form-element pubhub-smartsheet-calendar " + (valid ? "" : "has-danger")}
                key={field.id}>
                <div className="pubhub-smartsheet-label">
                    <label htmlFor={field.id} className="col-form-label">{title}</label>
                </div>
                <div className="pubhub-smartsheet-element"  key={id}>
                    <div className="inner-addon right-addon">
                        <i className="fas fa-calendar-alt" onClick={this.toggleCalender}></i>
                        <input className="form-control"
                               aria-describedby={field.id + 'passwordHelpBlock'}
                               id={field.id}
                               value={value}
                               onChange={this.handleChange}
                        >
                        </input>
                    </div>

                    {calender_el}
                    <small id={field.id + 'passwordHelpBlock'} className="form-text text-muted">{safeHelpText}</small>
                </div>
            </div>

        )
    }
}
